import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  create(data) {
    return BackendAPI('post', ApiRoutes.videoViewing.create(), data);
  },
  delete(id) {
    return BackendAPI('delete', ApiRoutes.videoViewing.delete(id));
  },
  validateId(id) {
    return BackendAPI('get', ApiRoutes.videoViewing.validateId(id));
  },
};
